import React from 'react';
import ReactDOM from 'react-dom';

import { FeatureFlagsProvider } from './common/components/FeatureToggle';
import * as serviceWorker from './serviceWorker';
import { App } from './App';

ReactDOM.render(
  <React.StrictMode>
    <FeatureFlagsProvider>
      <App />
    </FeatureFlagsProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
